// extracted by mini-css-extract-plugin
export default {"modal":"SummaryProductEditionModal_modal__rTXzy"};